import { render, staticRenderFns } from "./AddEditForm.vue?vue&type=template&id=c37ef056"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports